import * as Mui from "@material-ui/core";
import { makeStyles } from '@material-ui/core';
import { useTheme } from "../../../../../../../ThemeContext";

const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: '1.7rem',
        fontWeight: 500,
        marginBottom: theme.spacing(0.5)
    },
    description: {
        fontSize: '1.5rem',
        color: '#9aa1a7',
        fontWeight: 400,
    }
}));

export const RuleTitle = ({ title, subtitle }) => {
    return (
        <Mui.Typography variant="h5" className="font-weight-medium">
            {title}

            <Mui.Typography
                component="small"
                variant="body1"
                className=" text-color-grey d-block"
                // variant="body1"
                // className="font-weight-normal text-color-gray"

                style={{ marginTop: '0.5rem' }}
            >
                {subtitle}
            </Mui.Typography>
        </Mui.Typography>
    )
}

export const RuleTitle2 = ({ title, description }) => {
    const classes = useStyles();
    const { theme } = useTheme();
    return (
        <>
            <Mui.Typography variant="body1" className={classes.title} style={{ color: theme === 'dark' ? '#323239' : '#323239', }}>
                {title}
            </Mui.Typography>
            {description && <Mui.Typography className={classes.description}>
                {description}
            </Mui.Typography>}
        </>
    )
}